<a
        [routerLink]="route"
        [title]="title"
        [routerLinkActive]="'active text-primary'"
        *appIfPermission="[permission]"
        [ngClass]="[
          'min-w-0 rounded py-3 flex flex-row items-center text-sm font-bold hover:no-underline focus:no-underline',
    customColor === 'orange'
      ? 'text-orange-600 hover:bg-orange-100 router-link-active:bg-orange-100'
      : 'text-grayDark hover:bg-grayNavi hover:text-primaryDark router-link-active:bg-primaryWashed router-link-active:text-primaryDark'
  ]"
>
  <div
          class="relative text-lg flex flex-shrink-0 items-center justify-center w-10 min-w-0"
  >
    <ng-container *ngIf="icon; else imageIcon">
      <i [class]="icon"></i>
    </ng-container>
    <ng-template #imageIcon>
      <img
              [src]="imgSrc"
              alt="menu icon"
              style="width: 1em; height: 1em; object-fit: contain;"
      />
    </ng-template>

    <div
            *ngIf="notificationCount() > 0"
            class="absolute top-0 right-0 bg-orange text-white text-xs font-bold rounded-full h-5 px-2 flex items-center justify-center z-50 shadow-md transition-transform duration-300 hover:scale-110 pointer-events-auto whitespace-nowrap"
            [ngClass]="showAdditionalText() && !isShrunk ? 'h-auto py-1 px-3 -top-2 -right-2' : 'h-5 px-2 -top-2 -right-2'"
            [style.transform]="
              isShrunk && showAdditionalText() ? 'translate(86%, -90%)' :
              isShrunk ? 'translate(50%, -90%)' :
              showAdditionalText() ? 'translate(180%, -90%)' :
              'translate(410%, -90%)'
            "
            [title]="notificationTooltip"
            [attr.data-tooltip]="notificationTooltip"
    >
      <span class="tabular-nums">{{ notificationCount() }}</span>
      <span *ngIf="showAdditionalText()" class="ml-1" i18n>
        novih dražb danes
      </span>
    </div>

  </div>

  <!-- Label -->
  <span
          class="sidebar-item-label pl-1 pr-3 relative truncate"
          [ngClass]="{'sidebar-item-label--hidden': isShrunk}"
          style="top: 2px"
          i18n>
    {{ label }}
  </span>

  <span
          *ngIf="showNewBadge() && !isShrunk"
          class="bg-primary text-white text-[10px] font-bold rounded-full px-2 py-0.5 leading-none whitespace-nowrap"
          i18n="@@sidebar-item.new-badge">
    NOVO
  </span>
</a>
